module.exports = __webpack_public_path__ + "img/compass.deec0e1b.svg";